<!-- <div class="section-title">
  Interventions reçues
</div> -->
<app-intervention-list [processed]="false"></app-intervention-list>
<app-intervention-list [processed]="true"></app-intervention-list>
